import { renderSuccessMessage } from "src/assets/functions";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { ErrorMessage, Formik } from "formik";
import { Navigate } from "react-router-dom";
import { resetEmail } from "src/api";

const ResetEmail = ({ setIsOpen }) => {

    const signInSchema = yup.object().shape({
        email: yup
            .string()
            .email("Please provide a valid email")
            .required("Please provide a valid email"),

    });
    const initialValues = {
        email: "",
    };

    const { mutate, isLoading } = useMutation(resetEmail, {
        onSuccess: (data) => {
            renderSuccessMessage(data?.message);
            setIsOpen(false);
            Navigate(`/`);
        },

    });

    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={signInSchema}
                onSubmit={(values) => mutate(values)}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <input
                            type="email"
                            placeholder="Enter Email"
                            name="email"
                            onChange={handleChange}
                            value={values.email}
                            className="w-full border p-3 rounded-md mb-[35px] focus:outline-none focus:ring-2 focus:ring-green-500"
                        />
                        <ErrorMessage
                            name="email"
                            component="div"
                            className="text-red-500  error-message"
                        />
                        <button className="w-full text-white p-3 rounded-md transition login-up-btn mt-[25px]">
                            Reset Email
                        </button>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default ResetEmail;
